import React from "react";
import ReusableProfileContainer from "../../directorate/ui/ReusableProfileContainer";

export default function PastorProfileContainer() {
  return <ReusableProfileContainer />;
}
